/**
 * Two-step sign-in (Settings → Security). Once an author turns it on, the API answers 403
 * TWO_STEP_REQUIRED to a session that hasn't used a second factor; whichever request hears it sends
 * the author to the code screen, and back where they were afterwards.
 */
export const TWO_STEP_EVENT = "lilia:two-step-required";

export function announceTwoStepRequired() {
  if (typeof window !== "undefined") window.dispatchEvent(new CustomEvent(TWO_STEP_EVENT));
}

/** Where to go after the code: a path in the app only, never another site (an open redirect). */
export function safeReturn(raw: string | null | undefined, fallback = "/"): string {
  if (!raw || !raw.startsWith("/") || raw.startsWith("//") || raw.startsWith("/\\")) return fallback;
  if (raw.startsWith("/mfa-challenge") || raw.startsWith("/sign-in")) return fallback;
  return raw;
}
